"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var suplierCouponsApi = _suplierCouponsApi;
var _validate = require("@/utils/validate");
var _selectCompay = _interopRequireDefault(require("./selectCompay.vue"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectCompay: _selectCompay.default
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {
        brandList: []
      },
      details: {},
      // 预留一份数据
      supplierId: '',
      brandOption: []
    };
  },
  mounted: function mounted() {
    this.pram = {
      brandList: []
    };
  },
  methods: {
    throttle: _throttle.default,
    openInit: function openInit(supplierId) {
      var _this = this;
      this.supplierId = supplierId;
      this.details = {};
      this.pram = {
        brandList: []
      };
      this.searchBrand();
      suplierCouponsApi.getComDetail(supplierId).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _ref = res || {},
          companyId = _ref.companyId,
          companyName = _ref.companyName;
        _this.visible = true;
        _this.details = _objectSpread(_objectSpread({}, res), {}, {
          companyId: "".concat(companyId, "_").concat(companyName)
        });
        var _res$brandList = res.brandList,
          brandList = _res$brandList === void 0 ? [] : _res$brandList;
        _this.pram = {
          brandList: brandList && brandList.length && brandList.map(function (item) {
            var id = item.id,
              name = item.name;
            return "".concat(name, "--ID").concat(id);
          }) || []
        };
      });
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.loading = true;
      var _ref2 = this.pram || {},
        _ref2$brandList = _ref2.brandList,
        brandList = _ref2$brandList === void 0 ? [] : _ref2$brandList;
      suplierCouponsApi.UpdateBrand(_objectSpread(_objectSpread({}, this.details), {}, {
        supplierId: this.supplierId,
        brandList: brandList.length && brandList.map(function (item) {
          var _ref3 = item && item.split('--ID'),
            _ref4 = _slicedToArray(_ref3, 2),
            name = _ref4[0],
            id = _ref4[1];
          return {
            name: name,
            id: id
          };
        }) || []
      })).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.loading = false;
        _this2.visible = false;
        _this2.$emit('doRefresh');
      }).catch(function () {
        _this2.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    searchBrand: function searchBrand() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      suplierCouponsApi.getAllBrand(keyword).then(function (res) {
        _this3.brandOption = res && res.length && res.map(function (item) {
          var _ref5 = item || {},
            id = _ref5.id,
            brandName = _ref5.brandName;
          return {
            id: id,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(id)
          };
        }) || [];
      });
    },
    // 移除
    removeBrand: function removeBrand(i) {
      var brandList = this.pram.brandList;
      brandList.splice(i, 1);
      this.$set(this.pram, 'brandList', brandList);
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.searchBrand(data);
      }, 300)();
    }
  }
};